import { z } from 'zod';

export const ProdutoFotoSchema = z.object({
    prf_descricao: z.string().nullable(),
    prf_empresa_idpk: z.number(),
    prf_foto_path: z.string(),
    prf_foto_principal: z.union([z.literal(1), z.literal(0)]),
    prf_idpk: z.number(),
    prf_produto_idpk: z.number(),
    prf_ultima_alteracao: z.string(),
});

export type ProdutoFoto = z.infer<typeof ProdutoFotoSchema>;
